import * as THREE from 'three';
import FVector from '@data/geometry/FVector';
import type { SensorData } from 'Simulations/SensorPoint';
import { Facade } from './Facade';

export class FacadeWithOpenings extends Facade {
    private readonly opaqueMaterial: THREE.Material;
    private readonly transparentMaterial: THREE.Material;

    constructor(
        p1: FVector,
        p2: FVector,
        height: number,
        opaqueMaterial: THREE.Material,
        transparentMaterial: THREE.Material,
        sensors: SensorData[]
    ) {
        super(p1, p2, height, opaqueMaterial, sensors);
        this.opaqueMaterial = opaqueMaterial;
        this.transparentMaterial = transparentMaterial;
    }

    override build(): THREE.Group {
        const hasOpeningSensors = this.sensors.some((sensor) => sensor.getScalarValue() > 0);
        return this.buildFacadeQuad(
            this.p1,
            this.p2,
            this.height,
            hasOpeningSensors ? this.transparentMaterial : this.opaqueMaterial,
            FacadeWithOpenings.edgeMaterial
        );
    }
}
